import { IAction } from '../../interfaces/action.interface';
import { AdminTabsActionTypes } from './admin-tabs.action-types';

export const setAdminTabsActiveTab = (selectedTab: string): IAction => {
  return {
    type: AdminTabsActionTypes.SET_ADMIN_TAB,
    payload: selectedTab
  };
};
